// .context/CourseContext.js
import React, { createContext, useState } from "react";

export const CourseContext = createContext();

export const CourseProvider = ({ children }) => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);

  return (
    <CourseContext.Provider value={{ selectedCourse, setSelectedCourse, selectedLesson, setSelectedLesson }}>
      {children}
    </CourseContext.Provider>
  );
};
